import { PRICE_GROUPS, whatsappLink } from "../../data";
import { SectionHeading, Reveal } from "./Shared";

export const PriceList = () => {
  return (
    <section
      id="pricing"
      data-testid="pricing-section"
      className="relative py-28 px-6 bg-[#faf9f6]"
    >
      <div className="max-w-4xl mx-auto">
        <SectionHeading
          light
          eyebrow="Price List"
          title="Our Treatments & Rituals"
          subtitle="Transparent pricing for every moment of calm. Sessions from €68 per hour."
        />

        <div className="mt-16 space-y-14">
          {PRICE_GROUPS.map((group, gi) => (
            <Reveal key={group.title} delay={gi * 0.08}>
              <div data-testid={`price-group-${gi}`}>
                <h3 className="font-serif-display text-3xl text-[#151c0f] font-normal mb-1">
                  {group.title}
                </h3>
                <div className="w-full gold-hairline my-6" />
                <ul className="space-y-5">
                  {group.items.map((item, ii) => (
                    <li
                      key={item.name}
                      data-testid={`price-item-${gi}-${ii}`}
                      className="flex items-end"
                    >
                      <span className="font-serif-display text-lg sm:text-xl text-[#2d3a1f]">
                        {item.name}
                      </span>
                      <span className="dotted-leader" />
                      <span className="font-sans text-base font-semibold text-[#b89d62] whitespace-nowrap">
                        {item.price}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            data-testid="pricing-whatsapp-cta"
            href={whatsappLink()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-[#2d3a1f] hover:bg-[#151c0f] text-[#faf9f6] transition-colors duration-400 px-9 py-4 btn-label"
          >
            Reserve your session
          </a>
        </div>
      </div>
    </section>
  );
};
